/* Opalus Creations — behaviour.
   Motion is barely there and everything degrades to a working page without JS. */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- Nav */

  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('site-nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------- Chip radio groups */
  /* Size and budget pickers are real radio inputs wrapped in chip labels.
     Native validation and keyboard behaviour come free; this only mirrors
     the checked state onto the label so it reads as selected. */

  function syncChipRadios(scope) {
    var radios = (scope || document).querySelectorAll('.chip input[type="radio"]');
    Array.prototype.forEach.call(radios, function (radio) {
      var paint = function () {
        var group = document.querySelectorAll('input[name="' + radio.name + '"]');
        Array.prototype.forEach.call(group, function (r) {
          var label = r.closest('.chip');
          if (label) label.classList.toggle('is-selected', r.checked);
        });
      };
      radio.addEventListener('change', paint);
      radio.addEventListener('focus', function () {
        var label = radio.closest('.chip');
        if (label) label.style.outline = '2px solid var(--gilt)';
      });
      radio.addEventListener('blur', function () {
        var label = radio.closest('.chip');
        if (label) label.style.outline = '';
      });
      if (radio.checked) paint();
    });
  }
  syncChipRadios();

  /* -------------------------------------------------------- Reveal */

  var revealables = document.querySelectorAll('.reveal');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(revealables, function (el) { el.style.opacity = 1; });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(revealables, function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------ Product gallery + viewer */

  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var dataEl = gallery.querySelector('[data-gallery-data]');
    var images = [];
    try { images = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!images.length) return;

    var main = gallery.querySelector('[data-gallery-main]');
    var openBtn = gallery.querySelector('[data-gallery-open]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-select]'));

    var viewer = document.querySelector('[data-viewer]');
    var stage = viewer && viewer.querySelector('[data-viewer-stage]');
    var img = viewer && viewer.querySelector('[data-viewer-img]');
    var caption = viewer && viewer.querySelector('[data-viewer-caption]');
    var counter = viewer && viewer.querySelector('[data-viewer-count]');
    var zoomBtn = viewer && viewer.querySelector('[data-viewer-zoom]');
    var prevBtn = viewer && viewer.querySelector('[data-viewer-prev]');
    var nextBtn = viewer && viewer.querySelector('[data-viewer-next]');

    var current = 0;

    /* --- the page gallery ------------------------------------------------ */

    function select(index) {
      current = index;
      if (main && images[index]) {
        main.src = images[index].display;
        main.removeAttribute('srcset');
        main.alt = images[index].alt || '';
      }
      thumbs.forEach(function (t, i) {
        if (i === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
    });

    /* --- the viewer ------------------------------------------------------ */

    // No <dialog> support, or no viewer markup: the main image stays a plain
    // image and every photograph is still reachable via the thumbnails.
    if (!viewer || typeof viewer.showModal !== 'function') {
      if (openBtn) openBtn.style.cursor = 'default';
      return;
    }

    function setZoom(on) {
      stage.classList.toggle('is-zoomed', on);
      zoomBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      zoomBtn.textContent = on ? 'Zoom out' : 'Zoom in';
      if (on) {
        // Centre the zoomed image rather than parking at the top-left corner.
        stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2;
        stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2;
      }
    }

    img.addEventListener('load', function () { img.classList.add('is-ready'); });

    function show(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      current = index;
      setZoom(false);

      // Drop the old src before setting the new one. Changing src alone leaves
      // the previous photograph on screen until the new file arrives, so you
      // briefly see the wrong piece under the right caption.
      img.classList.remove('is-ready');
      img.removeAttribute('src');
      img.alt = images[index].alt || '';
      img.src = images[index].display;

      // Then upgrade to the full-resolution file in the background. Same
      // photograph, more detail — no flash, because it is already on screen.
      var hires = new Image();
      hires.onload = function () {
        if (current === index && viewer.open) img.src = images[index].full;
      };
      hires.src = images[index].full;

      caption.textContent = images[index].alt || '';
      counter.textContent = (index + 1) + ' / ' + images.length;
      var only = images.length < 2;
      prevBtn.disabled = only;
      nextBtn.disabled = only;
      select(index);
    }

    function open() {
      // Open first, so the stage has real dimensions before the image lands.
      viewer.showModal();
      document.documentElement.style.overflow = 'hidden';
      show(current);
    }

    function close() {
      setZoom(false);
      if (viewer.open) viewer.close();
    }

    if (openBtn) openBtn.addEventListener('click', function () { open(); });

    viewer.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (openBtn) openBtn.focus();
    });

    viewer.querySelector('[data-viewer-close]').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(current - 1); });
    nextBtn.addEventListener('click', function () { show(current + 1); });
    zoomBtn.addEventListener('click', function () {
      setZoom(!stage.classList.contains('is-zoomed'));
    });

    stage.addEventListener('click', function (event) {
      if (event.target !== img) { close(); return; }   // clicking the ground closes
      if (stage.classList.contains('is-zoomed')) { setZoom(false); return; }

      // The img element fills the stage but the photograph is letterboxed
      // inside it, so work out where the click landed on the picture itself
      // rather than on the element box.
      var box = img.getBoundingClientRect();
      var natW = img.naturalWidth || box.width;
      var natH = img.naturalHeight || box.height;
      var scale = Math.min(box.width / natW, box.height / natH);
      var shownW = natW * scale;
      var shownH = natH * scale;
      var left = box.left + (box.width - shownW) / 2;
      var top = box.top + (box.height - shownH) / 2;

      var fx = Math.min(1, Math.max(0, (event.clientX - left) / shownW));
      var fy = Math.min(1, Math.max(0, (event.clientY - top) / shownH));

      // Clicking the ground beside a letterboxed image should close, not zoom.
      if (event.clientX < left || event.clientX > left + shownW ||
          event.clientY < top || event.clientY > top + shownH) { close(); return; }

      setZoom(true);
      // Keep the point that was clicked under the cursor.
      stage.scrollLeft = fx * stage.scrollWidth - stage.clientWidth / 2;
      stage.scrollTop = fy * stage.scrollHeight - stage.clientHeight / 2;
    });

    viewer.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
    });
  })();

  /* -------------------------------------------------------- Shop filters */

  var filterBar = document.querySelector('[data-filters]');
  var grid = document.querySelector('[data-grid]');
  if (!filterBar || !grid) return;

  var countEl = document.querySelector('[data-result-count]');
  var emptyEl = document.querySelector('[data-empty]');
  var pieces = Array.prototype.slice.call(grid.querySelectorAll('[data-piece]'));
  var state = { type: 'All', stone: 'All', band: 'All' };

  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    ['type', 'stone', 'band'].forEach(function (key) {
      var value = params.get(key);
      if (value) state[key] = value;
    });
  }

  function writeUrl(push) {
    var params = new URLSearchParams(window.location.search);
    ['type', 'stone', 'band'].forEach(function (key) {
      if (state[key] === 'All') params.delete(key);
      else params.set(key, state[key]);
    });
    var query = params.toString();
    var url = window.location.pathname + (query ? '?' + query : '');
    if (push) history.pushState(null, '', url);
    else history.replaceState(null, '', url);
  }

  function paintChips() {
    var chips = filterBar.querySelectorAll('.chip[data-filter]');
    Array.prototype.forEach.call(chips, function (chip) {
      var key = chip.getAttribute('data-filter');
      var on = chip.getAttribute('data-value') === state[key];
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function apply() {
    var shown = 0;
    pieces.forEach(function (piece) {
      // data-stone holds the piece's stone FAMILIES, pipe-separated — a piece
      // can carry several stones, so this is a membership test, not equality.
      var pieceFamilies = (piece.getAttribute('data-stone') || '').split('|');
      var ok =
        (state.type === 'All' || piece.getAttribute('data-type') === state.type) &&
        (state.stone === 'All' || pieceFamilies.indexOf(state.stone) !== -1) &&
        (state.band === 'All' || piece.getAttribute('data-band') === state.band);
      piece.hidden = !ok;
      if (ok) shown++;
    });

    if (countEl) countEl.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
    if (emptyEl) emptyEl.hidden = shown !== 0;
    grid.hidden = shown === 0;
    paintChips();
  }

  filterBar.addEventListener('click', function (event) {
    var chip = event.target.closest('.chip[data-filter]');
    if (!chip) return;
    state[chip.getAttribute('data-filter')] = chip.getAttribute('data-value');
    writeUrl(true);
    apply();
  });

  window.addEventListener('popstate', function () {
    state = { type: 'All', stone: 'All', band: 'All' };
    readUrl();
    apply();
  });

  readUrl();
  writeUrl(false);
  apply();
})();
